import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

declare global {
  interface Window {
    fbq: any;
  }
}

const MetaPixelTracker: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  const lastInitializedId = React.useRef<string | null | undefined>(undefined);
  const lastInitializedDataStr = React.useRef<string | null>(null);

  useEffect(() => {
    if (!window.fbq) return;

    const pixelId = '3513959945425304';
    let currentUserId = user?.id ? user.id.toString() : 'guest';
    let initData: any = undefined;

    if (user) {
      // Giriş yapmış kullanıcı için gelişmiş eşleştirme
      initData = {
        em: user.email.toLowerCase(),
        ph: user.phone ? user.phone.replace(/[^0-9]/g, '') : undefined,
        fn: user.name.split(' ')[0].toLowerCase(),
        ln: user.name.split(' ').slice(1).join(' ').toLowerCase(),
        external_id: user.id.toString()
      };
    } else {
      // Misafir için localStorage'da davetiye takip verisi var mı bak (Advanced Matching for guests)
      try {
        // En son kaydedilen guest tracking verisini bulmaya çalış
        const guestDataKeys = Object.keys(localStorage).filter(k => k.startsWith('guest_tracking_'));
        if (guestDataKeys.length > 0) {
          // alfabetik sırada en sonuncuyu al (genelde en son ziyaret edilen davetiyedir)
          const latestKey = guestDataKeys.sort().reverse()[0];
          const stored = localStorage.getItem(latestKey);
          if (stored) {
            initData = JSON.parse(stored);
            currentUserId = 'guest_' + (initData.external_id || latestKey);
          }
        }
      } catch (e) {
        console.warn('Guest tracking parse error in tracker', e);
      }
    }

    const dataStr = JSON.stringify(initData || {});
    // Eğer hem ID hem de veri aynıysa tekrar init yapma
    if (lastInitializedId.current === currentUserId && (window as any)._fbq_last_init_str === dataStr) return;

    if (initData) {
      window.fbq('init', pixelId, initData);
    } else {
      window.fbq('init', pixelId);
    }

    lastInitializedId.current = currentUserId;
    (window as any)._fbq_last_init_str = dataStr;
  }, [user?.id, location.pathname]); 

  useEffect(() => {
    if (!window.fbq) return;
    
    // PageView olayını her sayfa değişiminde gönder
    window.fbq('track', 'PageView');
  }, [location.pathname]);

  return null;
};

export default MetaPixelTracker;
